import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import './styles/globals.css'

/** Shown during route transitions so navigation feels instant */
function NavigationPending() {
  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] h-0.5 bg-[var(--netflix-red)] animate-pulse opacity-90 rounded-r-full" />
  )
}

// Prevent page reloads on errors
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  // Prevent default error handling that might cause reload
  event.preventDefault();
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // Prevent default error handling that might cause reload
  event.preventDefault();
});

// Create a new router instance with instant navigation feedback
const router = createRouter({
  routeTree,
  defaultPendingComponent: NavigationPending,
  defaultPendingMs: 80,
  defaultPendingMinMs: 120,
  defaultPreload: 'intent',
  defaultPreloadDelay: 50,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
